import { Slider } from 'component/Slider'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import { INCH } from 'type/LengthUnit'

type Props = {
  min: number
  max: number
  value: number
  onChange(value: number): void
}

export function isMax(value: number, max: number): boolean {
  const inch = store.profile.unit === 'in'
  max = inch ? Math.round(max / INCH) : max
  value = inch ? Math.round(value / INCH) : value
  return value === max
}

export const SizeSlider = observer((props: Props) => {
  const inch = store.profile.unit === 'in'

  const min = inch ? Math.round(props.min / INCH) : props.min
  const max = inch ? Math.round(props.max / INCH) : props.max
  const value = inch ? Math.round(props.value / INCH) : props.value

  const onChange = useLatestCallback((value: number) => {
    if (inch) value = value * INCH
    props.onChange(value)
  })

  return <Slider min={min} max={max} value={value} onChange={onChange} />
})
